import { render, staticRenderFns } from "./AccountingHelp.vue?vue&type=template&id=5126f366&"
import script from "./AccountingHelp.vue?vue&type=script&lang=js&"
export * from "./AccountingHelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports